import script from "./SyncAppPage.vue?vue&type=script&lang=ts&setup=true"
export * from "./SyncAppPage.vue?vue&type=script&lang=ts&setup=true"

import "./SyncAppPage.vue?vue&type=style&index=0&id=4d2c235f&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4d2c235f"]])

export default __exports__